/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TimezoneModel {
    getFixupPrototypeFunction() { return TimezoneModel.fixupPrototype; }

    static newInstance(model: Partial<TimezoneModel>): TimezoneModel {
        let obj = Object.assign(new TimezoneModel(), model);
        TimezoneModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TimezoneModel>): TimezoneModel {
        if (!model) return null;
        return TimezoneModel.newInstance(<TimezoneModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TimezoneModel) {
        if (!obj) return;

        models.TimezoneModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TimezoneModel): boolean {
        Object.setPrototypeOf(obj, TimezoneModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the Timezone such as Asia/Kolkata, Asia/Dubai and so on.
     */
    id: string;

    /**
     * Raw offset of the timezone. It means the amount of time in milliseconds to add to UTC to get standard time in the required time zone.
     */
    raw_offset: string;

}
